import { styled } from '@/theme/index';

export const HeaderNavContainer = styled('div')(({ theme }) => ({
  display: 'contents',
  '&.vin-nav': {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    paddingLeft: theme.spacing(2),
    maxWidth: 1296,
    width: 'calc(100% - 250px)',
    [theme.breakpoints.down('md')]: {
      display: 'contents',
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 0,
    },
  },
}));

export const HeaderNav = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  display: 'none',
  margin: theme.spacing(0.5),
  padding: 0,
  '&.search-nav': {
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  '&.side-nav': {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}));

export const TabText = styled('p')(({ theme }) => ({
  fontSize: 18,
  margin: theme.spacing(0),
  lineHeight: '20px',
  position: 'relative',
  display: 'block',
  padding: theme.spacing(1),
  '&.placeholder': {
    color: '#535353',
  },
  '&.menu-toggle': {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(1)} ${theme.spacing(0)}`,
    },
  },
}));

export const SmartSearchInputWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  justifyContent: 'center',
  height: 'fit-content',
  alignSelf: 'center',

  position: 'relative',
  display: 'inline-block',
  borderRadius: '50px',
  padding: `${theme.spacing(0.25)}`,
  background:
    'linear-gradient(90deg, #4A3B8F 5.21%, #638A3A 73.57%, #81B44C 130.21%)',

  '&.error': {
    background: theme.palette.error.main,
  },
}));
